import { Field, useFormikContext } from "formik";
import { FC } from "react";
import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import { ExpiryReason } from "@/models/ExpiryReason";
import { Name } from "@/models/Name";
import SettingSelectField from "../settingFields/SettingSelectField";
import Label from "../label/label";
import Tooltip from "../Tooltip/Tooltip";
import { EXPIRY_UNIT_TYPE } from "@/constants/expiry-reason-constant";

const ExpiryReasonCard: FC = () => {
    const { errors, values } = useFormikContext<ExpiryReason>();
    const { translate } = useLocale();
    const unitOptions: Name[] = [
        { value: EXPIRY_UNIT_TYPE.DAYS.toString(), label: translate.byKey(TranslationKeys.days) },
        { value: EXPIRY_UNIT_TYPE.WEEKS.toString(), label: translate.byKey(TranslationKeys.weeks) },
        { value: EXPIRY_UNIT_TYPE.MONTHS.toString(), label: translate.byKey(TranslationKeys.months) },
    ];

    return <div className="w-full p-2 inline-flex justify-start items-center bg-white">
        <div className="ml-8 mr-5  card-details">
            <div className="text-1xl text-portal-blue-primary-shade2 font-bold text-ellipsis bound-title" title={values.name}>{values.name}</div>
        </div>
        <div className="flex flex-col">
            <div className="flex flex-col py-1">
                <div className="flex flex-row justify-between" id="nameLabel">
                    <Label htmlFor="name" className="text-xs text-gray-600 mt-1" required>
                        {translate.byKey(TranslationKeys.name)}:
                    </Label>
                    {errors.name && <span className="text-red-600 text-xs">{errors.name}</span>}
                </div>
                <Field
                    type="text"
                    name="name"
                    id="nameInput"
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input" />
            </div>
            <div className="flex flex-col py-1">
                <SettingSelectField
                    accessor="durationUnit"
                    displayName={translate.byKey(TranslationKeys.units)}
                    required
                    options={unitOptions}
                    className="w-full"/>
            </div>
        </div>
        <div className="flex flex-col">
            <div className="flex flex-col px-4 py-1">
                <div className="flex flex-row justify-between" id="durationValueLabel">
                    <Label htmlFor="durationValue" className="text-xs text-gray-600 mt-1" required>
                        {translate.byKey(TranslationKeys.duration)}:
                    </Label>
                    {errors.durationValue && <span className="text-red-600 text-xs">{errors.durationValue}</span>}
                </div>
                <Field
                    type="text"
                    name="durationValue"
                    id="durationValueId"
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input" />
            </div>
            <div className="flex flex-col px-4 py-1">
                <div className="flex flex-row justify-between" id="durationWarnValueLabel">
                    <Tooltip text={translate.byKey(TranslationKeys.durationWarningTip)} direction="bottom" show={true} contentPositionX="start">
                        <Label htmlFor="durationWarnValue" className="text-xs text-gray-600 mt-1" required>
                            {translate.byKey(TranslationKeys.durationWarning)}:
                        </Label>
                    </Tooltip>
                    {errors.durationWarnValue && <span className="text-red-600 text-xs">{errors.durationWarnValue}</span>}
                </div>
                <Field
                    type="text"
                    name="durationWarnValue"
                    id="durationWarnValueId"
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"/>
            </div>
        </div>
    </div>
    
};

export default ExpiryReasonCard;
